import { supportServiceConnectClient } from "api";

import {
  AdminListWebhooksRequest,
  AdminListWebhooksResponse,
  AdminUpdateWebhookRequest,
  AdminUpdateWebhookResponse,
} from "@safetyculture/s12-apis-connect-web/s12/webhooks/v1/webhooks_pb";

import { RequestMetadata } from "api/types";

type ListWebhooksParams = {
  organisationID: string;
};

export const listWebhooks = async (
  { organisationID }: ListWebhooksParams,
  headers: Record<RequestMetadata, string>,
): Promise<AdminListWebhooksResponse> => {
  const req = new AdminListWebhooksRequest({ organisationId: organisationID });
  return supportServiceConnectClient.adminListWebhooks(req, { headers });
};

type UpdateWebhookParams = {
  organisationID: string;
  webhookID: string;
  enabled: boolean;
};

export const enableDisableWebhook = async (
  { organisationID, webhookID, enabled }: UpdateWebhookParams,
  headers: Record<RequestMetadata, string>,
): Promise<AdminUpdateWebhookResponse> => {
  const req = new AdminUpdateWebhookRequest({
    organisationId: organisationID,
    webhookId: webhookID,
    enabled: enabled,
  });
  return supportServiceConnectClient.adminUpdateWebhook(req, { headers });
};
